import AvatarMock from "./assets/profile_example.jpg"
const statsMock = [{
  stsDate:"18/05/2020",
  stsOrdersQt:20,
  stsTotal:5340,
  stsTakeAwayQt:16,
  stsDeliveryQt:4,
  stsCashQt:4,
  stsCardQt:16,
  menuItems:[
    {
      stsMnuName:"Papas con huevo",
      stsOrdersQt:3,
      stsTotal:340,
      stsTakeAwayQt:2,
      stsDeliveryQt:1,
      stsCashQt:2,
      stsCardQt:1
    },
    {
      stsMnuName:"Pizzas",
      stsOrdersQt:17,
      stsTotal:5000,
      stsTakeAwayQt:1,
      stsDeliveryQt:16,
      stsCashQt:0,
      stsCardQt:17
    },
    {
      stsMnuName:"Hamburguesas",
      stsOrdersQt:0,
      stsTotal:0,
      stsTakeAwayQt:0,
      stsDeliveryQt:0,
      stsCashQt:0,
      stsCardQt:0
    }
  ]
},
{
  stsDate:"25/05/2020",
  stsOrdersQt:30,
  stsTotal:7313,
  stsTakeAwayQt:10,
  stsDeliveryQt:20,
  stsCashQt:14,
  stsCardQt:16,
  menuItems:[
    {
      stsMnuName:"Papas con huevo",
      stsOrdersQt:13,
      stsTotal:2313,
      stsTakeAwayQt:7,
      stsDeliveryQt:6,
      stsCashQt:3,
      stsCardQt:10
    },
    {
      stsMnuName:"Pizzas",
      stsOrdersQt:17,
      stsTotal:5000,
      stsTakeAwayQt:4,
      stsDeliveryQt:13,
      stsCashQt:2,
      stsCardQt:15
    },
    {
      stsMnuName:"Hamburguesas",
      stsOrdersQt:0,
      stsTotal:0,
      stsTakeAwayQt:0,
      stsDeliveryQt:0,
      stsCashQt:0,
      stsCardQt:0
    }
  ]
},
{
  stsDate:"01/06/2020",
  stsOrdersQt:65,
  stsTotal:4540,
  stsTakeAwayQt:45,
  stsDeliveryQt:20,
  stsCashQt:43,
  stsCardQt:22,
  menuItems:[
    {
      stsMnuName:"Papas con huevo",
      stsOrdersQt:5,
      stsTotal:2540,
      stsTakeAwayQt:2,
      stsDeliveryQt:3,
      stsCashQt:4,
      stsCardQt:1
    },
    {
      stsMnuName:"Pizzas",
      stsOrdersQt:10,
      stsTotal:3000,
      stsTakeAwayQt:6,
      stsDeliveryQt:4,
      stsCashQt:1,
      stsCardQt:9
    },
    {
      stsMnuName:"Hamburguesas",
      stsOrdersQt:50,
      stsTotal:10000,
      stsTakeAwayQt:20,
      stsDeliveryQt:30,
      stsCashQt:2,
      stsCardQt:48
    }
  ]
},
{
  stsDate:"08/06/2020",
  stsOrdersQt:65,
  stsTotal:4540,
  stsTakeAwayQt:45,
  stsDeliveryQt:20,
  stsCashQt:43,
  stsCardQt:22,
  menuItems:[
    {
      stsMnuName:"Papas con huevo",
      stsOrdersQt:5,
      stsTotal:2540,
      stsTakeAwayQt:2,
      stsDeliveryQt:3,
      stsCashQt:4,
      stsCardQt:1
    },
    {
      stsMnuName:"Pizzas",
      stsOrdersQt:10,
      stsTotal:3000,
      stsTakeAwayQt:6,
      stsDeliveryQt:4,
      stsCashQt:1,
      stsCardQt:9
    },
    {
      stsMnuName:"Hamburguesas",
      stsOrdersQt:50,
      stsTotal:10000,
      stsTakeAwayQt:20,
      stsDeliveryQt:30,
      stsCashQt:2,
      stsCardQt:48
    }
  ]
}]

const topClient = [
  {
  points:Math.round(Math.random()*110),
  name:"Juancito",
  photo:AvatarMock
  },
  {
  points:Math.round(Math.random()*110),
  name:"Pedrito",
  photo:AvatarMock
  },
  {
  points:Math.round(Math.random()*110),
  name:"Jaimito",
  photo:AvatarMock
  },
  {
  points:Math.round(Math.random()*110),
  name:"Marcelito",
  photo:AvatarMock
  },
  {
  points:Math.round(Math.random()*110),
  name:"Tito",
  photo:AvatarMock
  },
  {
  points:Math.round(Math.random()*110),
  name:"Pepito",
  photo:AvatarMock
  },
]

const topMenu = [
  {
  points:Math.round(Math.random()*110),
  name:"Milas con fritas",
  photo:AvatarMock
  },
  {
  points:Math.round(Math.random()*110),
  name:"Hamburguejas",
  photo:AvatarMock
  },
  {
  points:Math.round(Math.random()*110),
  name:"Panchos digital",
  photo:AvatarMock
  },
  {
  points:Math.round(Math.random()*110),
  name:"Morrones",
  photo:AvatarMock
  },
  {
  points:Math.round(Math.random()*110),
  name:"Sanguches",
  photo:AvatarMock
  },

]
export default {
                statsMock:statsMock
              , topClient:topClient
              , topMenu:topMenu
              }


// WEBPACK FOOTER //
// ./src/common/Mocks.js